import React from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import GeneralDialogLayout from '@Containers/Dialogs/GeneralDialogLayout/GeneralDialogLayout';
import './CopyStructureToQueryModal.scss';
import Button from '@Components/Button';
import { closeDialog } from '@Containers/Dialogs/DialogsActions';
import { typeOfCopyStructureToQueryModal } from './CopyStructureToQueryModalConstants';

function CopyStructureToQueryModal(props) {
  const { redirectToQuery } = props;
  const dispatch = useDispatch();
  return (
    <GeneralDialogLayout
      className="copy-structure-to-query-modal"
      {...props}
      headerClassName="rx-border-none"
      footerClassName="rx-border-none"
      header={
        <div className="copy-structure-to-query-modal-header">
          <h4 className="rx-newmodal-title">Copy structure to query</h4>
        </div>
      }
      footer={
        <div className="copy-structure-to-query-modal-footer">
          <span className="rx-btn-group--right copy-Structure-to-query-btn-group">
            <Button
              type="button"
              name="cancel"
              aria-label="Cancel"
              tabIndex="0"
              onClick={() => {
                dispatch(
                  closeDialog({
                    id: typeOfCopyStructureToQueryModal,
                  })
                );
              }}
              buttonConfig={{
                type: 'tertiary',
                size: 'sm',
                label: 'Cancel',
                e2eName: 'copy-to-query-cancel',
              }}
              iconConfig={{ name: 'delete', size: 'sm' }}
            />
            <Button
              type="Copy to query"
              name="copy to query"
              tabIndex="0"
              aria-label="Copy to query"
              onClick={() => {
                redirectToQuery();
                dispatch(
                  closeDialog({
                    id: typeOfCopyStructureToQueryModal,
                  })
                );
              }}
              buttonConfig={{
                type: 'primary',
                size: 'sm',
                label: 'Copy to query',
                e2eName: 'copy-to-query-save',
              }}
              iconConfig={{ name: 'chevron-right' }}
            />
          </span>
        </div>
      }>
      <div className="copy-structure-to-query__content">
        <div className="copy-structure-to-query__content_text u-els-font-size-h5">
          <div>Are you sure you want to overwrite your current structure search?</div>
        </div>
      </div>
    </GeneralDialogLayout>
  );
}

CopyStructureToQueryModal.defaultProps = {
  redirectToQuery: () => {},
};
CopyStructureToQueryModal.propTypes = {
  redirectToQuery: PropTypes.func,
};

export default CopyStructureToQueryModal;
